<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 182 132"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>sports-enthusiasts</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-53.000000, -233.000000)">
        <g
          id="sports-enthusiasts"
          transform="translate(54.000000, 233.000000)">
          <g id="Background">
            <path
              id="Path"
              d="M173.793126,82.7586207 C173.789938,48.9612634 153.235897,18.5617393 121.872585,5.96792915 C90.5092735,-6.62588101 54.6393699,1.11683759 31.263446,25.5264168 C7.88752222,49.935996 1.70313471,86.1071589 15.6413793,116.896552 L166.427586,116.896552 C171.290434,106.173132 173.801854,94.5331244 173.793126,82.7586207 L173.793126,82.7586207 Z"
              class="fill-extra-light"
              fill-rule="nonzero" />
            <line
              id="Path"
              x1="9.31034483"
              y1="116.896552"
              x2="170.689655"
              y2="116.896552"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="0"
              y1="116.896552"
              x2="5.17241379"
              y2="116.896552"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="174.827586"
              y1="116.896552"
              x2="180"
              y2="116.896552"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <g
            id="Scene"
            transform="translate(28.965517, 10.344828)">
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="26.1517241"
              cy="117.931034"
              rx="22.7586207"
              ry="3.10344828" />
            <circle
              id="Oval"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="translate(26.644952, 94.474467) rotate(-80.750000) translate(-26.644952, -94.474467) "
              cx="26.6449518"
              cy="94.4744667"
              r="22.4068966" />
            <polygon
              id="Path"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="31.8206897 103.096552 21.4758621 103.096552 16.3034483 91.0344828 26.6482759 84.1241379 36.9931034 91.0344828" />
            <path
              id="Path"
              d="M17.6896552,73.9448276 L26.6482759,79.5310345 L35.6068966,73.9448276 C29.8980895,71.4353509 23.3984623,71.4353509 17.6896552,73.9448276 L17.6896552,73.9448276 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M43.4482759,79.7586207 L40.8206897,89.9793103 L48.8482759,96.8275862 C49.169999,93.7627774 48.8601762,90.6645499 47.937931,87.7241379 C47.0142459,84.784491 45.4848313,82.0710135 43.4482759,79.7586207 L43.4482759,79.7586207 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M45.7655172,106.158621 L35.1724138,106.696552 L31.0344828,116.42069 C37.1495232,115.173704 42.462379,111.421687 45.6827586,106.075862 L45.7655172,106.158621 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M21.2689655,116.213793 L17.5655172,106.344828 L7.05517241,105.331034 C10.0713964,110.779256 15.2225645,114.723236 21.2689655,116.213793 L21.2689655,116.213793 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M4.30344828,95.8965517 L12.5793103,89.3793103 L10.3862069,79.0344828 C6.04558694,83.5285406 3.79328146,89.6397961 4.17931034,95.8758621 L4.30344828,95.8965517 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="26.6482759"
              y1="84.1241379"
              x2="26.6482759"
              y2="79.5310345"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="36.9931034"
              y1="91.0344828"
              x2="40.9034483"
              y2="89.9793103"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="16.3034483"
              y1="91.0344828"
              x2="12.6"
              y2="89.3793103"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="31.8206897"
              y1="103.096552"
              x2="35.2344828"
              y2="106.696552"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="21.4758621"
              y1="103.096552"
              x2="17.5655172"
              y2="106.344828"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M85.862069,58.4068966 C67.6137931,58.4068966 52.7586207,73.8 52.7586207,90.7862069 L52.7586207,93.1034483 C52.7586207,94.2461064 53.6849281,95.1724138 54.8275862,95.1724138 L65.1724138,95.1724138 L65.1724138,106.551724 L106.551724,106.551724 L106.551724,95.1724138 L116.896552,95.1724138 C118.03921,95.1724138 118.965517,94.2461064 118.965517,93.1034483 L118.965517,90.7862069 C118.965517,73.8 104.110345,58.4068966 85.862069,58.4068966 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M85.862069,58.4068966 C67.6137931,58.4068966 52.7586207,73.8 52.7586207,90.7862069 L52.7586207,93.1034483 C52.7586207,94.2461064 53.6849281,95.1724138 54.8275862,95.1724138 L65.1724138,95.1724138 L65.1724138,106.551724 L106.551724,106.551724 L106.551724,95.1724138 L116.896552,95.1724138 C118.03921,95.1724138 118.965517,94.2461064 118.965517,93.1034483 L118.965517,90.7862069 C118.965517,73.8 104.110345,58.4068966 85.862069,58.4068966 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M105.517241,65.0482759 C104.110345,74.7310345 105.165517,85.0137931 106.510345,95.2965517"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="118.965517"
              y1="90"
              x2="105.889655"
              y2="90"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round" />
            <path
              id="Path"
              d="M66.2068966,65.0275862 C67.6344828,74.7310345 66.5586207,85.0137931 65.2137931,95.2965517"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="52.7586207"
              y1="90"
              x2="65.8344828"
              y2="90"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="54.8275862"
              y="95.1724138"
              width="10.3448276"
              height="11.3793103" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="106.551724"
              y="95.1724138"
              width="10.3448276"
              height="11.3793103" />
            <path
              id="Path"
              d="M100.365517,75.5172414 L98.7517241,63.7862069 C98.2581315,61.268132 96.6433281,59.1125218 94.3655172,57.9310345 L94.3655172,57.9310345 C93.1655172,57.6413793 91.9241379,60 90.662069,59.7931034 L85.862069,60.4137931 L81.0827586,59.7931034 C79.8206897,59.937931 78.5793103,57.7241379 77.3793103,57.9310345 L77.3793103,57.9310345 C75.1065004,59.1081725 73.4924629,61.255147 72.9931034,63.7655172 L71.3793103,75.5172414 C71.33364,75.8468116 71.4714058,76.1750449 71.7386122,76.3732948 C72.0058186,76.5715448 72.3598961,76.6082274 72.662069,76.4689655 L85.862069,72.3310345 L99.0827586,76.4689655 C99.3849315,76.6082274 99.739009,76.5715448 100.006215,76.3732948 C100.273422,76.1750449 100.411188,75.8468116 100.365517,75.5172414 L100.365517,75.5172414 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M77.5862069,52.7586207 L77.5862069,63.8275862 C77.5862069,63.8275862 83.2137931,71.3793103 85.862069,71.3793103 C88.5103448,71.3793103 94.137931,63.8275862 94.137931,63.8275862 L94.137931,52.7586207 L77.5862069,52.7586207 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M77.5862069,52.7586207 L77.5862069,63.8275862 C77.5862069,63.8275862 83.2137931,71.3793103 85.862069,71.3793103 C88.5103448,71.3793103 94.137931,63.8275862 94.137931,63.8275862 L94.137931,52.7586207 L77.5862069,52.7586207 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M98.2758621,48.6206897 C105.744828,60 115.593103,59.6896552 126.206897,51.7241379 C118.613793,48.2689655 115.862069,42.4137931 115.862069,34.137931 L115.862069,11.5448276 C115.862069,6.31145347 111.619581,2.06896552 106.386207,2.06896552 L106.386207,2.06896552 C101.485188,2.08757663 97.2698308,5.54278709 96.2896552,10.3448276 C93.1034483,25.0965517 93.1034483,38.2551724 98.2758621,48.6206897 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              cx="101.896552"
              cy="7.75862069"
              r="7.75862069" />
            <path
              id="Path"
              d="M85.8827586,0 L85.8827586,0 C71.5655172,0 60,12.4137931 60,27.9310345 C60,41.0068966 111.724138,41.0275862 111.724138,27.9310345 C111.724138,12.4137931 100.158621,0 85.8827586,0 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M85.8827586,0 L85.8827586,0 C71.5655172,0 60,12.4137931 60,27.9310345 C60,41.0068966 111.724138,41.0275862 111.724138,27.9310345 C111.724138,12.4137931 100.158621,0 85.8827586,0 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M106.551724,30 C93.8482759,27.4758621 85.4896552,22.262069 76.7172414,14.0482759 C75.4344828,21.9103448 72.9103448,30 65.1724138,30 C62.8870976,30 61.0344828,31.8526148 61.0344828,34.137931 C61.0344828,36.4232472 62.8870976,38.2758621 65.1724138,38.2758621 L65.4206897,38.2758621 C66.9950073,48.3463496 75.6692678,55.7699198 85.862069,55.7699198 C96.0548701,55.7699198 104.729131,48.3463496 106.303448,38.2758621 L106.551724,38.2758621 C108.83704,38.2758621 110.689655,36.4232472 110.689655,34.137931 C110.689655,31.8526148 108.83704,30 106.551724,30 L106.551724,30 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="73.9655172"
              cy="38.7931034"
              r="2.5862069" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="97.7586207"
              cy="38.7931034"
              r="2.5862069" />
            <path
              id="Path"
              d="M92.0689655,44.0482759 C88.6059206,47.39051 83.1182173,47.39051 79.6551724,44.0482759"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M80.6896552,32.0689655 C80.1603673,30.8243382 78.938702,30.0163182 77.5862069,30.0163182 C76.2337118,30.0163182 75.0120465,30.8243382 74.4827586,32.0689655"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M97.2413793,32.0689655 C96.7120915,30.8243382 95.4904261,30.0163182 94.137931,30.0163182 C92.785436,30.0163182 91.5637706,30.8243382 91.0344828,32.0689655"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
